import React from "react";
import { Accordion, List, Icon, Popup } from "semantic-ui-react";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import { AclResource } from "../../../../types/acl";
import { FineGrainedPermission, Permission } from "../../../../types/permissions";
import { Role } from "../../../../types/roles";
import { exists } from "../../../../utils/utils";
import Resource from "./Resource";

type MyPermissionsProps = {
  administrators: string[];
  permissions: Permission[];
  fineGrainedPermissions: FineGrainedPermission[];
  fineGranularity?: unknown[];
  role: Role | Record<string, never>;
};

type MyPermissionsState = { isActive: boolean };

class MyPermissions extends React.PureComponent<MyPermissionsProps, MyPermissionsState> {
  resources = (this.props.role.aclResourcesActions || []).reduce<AclResource[]>(
    (resources, permission) =>
      exists(resources.find(resource => resource.id === permission.resourceId))
        ? resources
        : resources.concat(permission.aclResource),
    []
  );

  state = { isActive: false };
  handleClick = () =>
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));

  resourcesPanelsForRole = (role: Role) => (
    <Accordion key={role.id} style={{ minWidth: "300px" }} exclusive={false}>
      {this.resources.map(resource => (
        <Resource
          canEdit={false}
          key={role.id + resource.id}
          role={this.props.role}
          resource={resource}
          permissions={this.props.permissions}
          fineGranularity={this.props.role.aclRolesFineGrainedResourcesActions}
          fineGrainedPermissions={this.props.fineGrainedPermissions}
        />
      ))}
    </Accordion>
  );

  render() {
    return (
      <>
        <h3>My Permissions ({this.props.role.name})</h3>
        <Segment style={{ margin: 0 }} key={this.props.role.id}>
          {/* @ts-ignore until typing exists */}
          {exists(this.props.role) ? this.resourcesPanelsForRole(this.props.role) : undefined}
        </Segment>
        <p style={{ color: "gray", marginTop: "2%" }}>
          Permissions can only be changed by your administrator(s):
          <Popup
            flowing
            hoverable
            position="right center"
            trigger={<Icon link name="user circle" />}
            content={
              <List style={{ color: "grey" }}>
                {this.props.administrators.map((admin, index) => (
                  <List.Item key={index}>{admin}</List.Item>
                ))}
              </List>
            }
          />
        </p>
      </>
    );
  }
}

export default MyPermissions;
